import { API_URL } from "../../config/connect";

const getAuthHeaders = () => {
  const token = localStorage.getItem('google_id_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * List User Announcements
 * GET /api/v1/sales-manager/users/{user_id}/announcements
 * @param {number} userId - User ID
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number (default: 1)
 * @param {number} params.limit - Items per page (default: 10, max: 100)
 * @param {string} params.status - Filter by status: active, pending, rejected, inactive
 * @returns {Promise<Object>} List of announcements with pagination
 */
export const getUserAnnouncements = async (userId, params = {}) => {
  try {
    let url = `${API_URL}/api/v1/sales-manager/users/${userId}/announcements`;
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.status) queryParams.append('status', params.status);
    
    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }

    const response = await fetch(url, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(errorData.detail || errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching user announcements:', error);
    throw error;
  }
};

/**
 * Get Announcement Details
 * GET /api/v1/sales-manager/announcements/{announcement_id}
 * @param {number} announcementId - Announcement ID
 * @returns {Promise<Object>} Announcement details
 */
export const getAnnouncementDetails = async (announcementId) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/sales-manager/announcements/${announcementId}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(errorData.detail || errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching announcement details:', error);
    throw error;
  }
};






